import { useState } from "react";

import { Flex, Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { CalendarIcon, InputPasswordNumbersIcon } from "ui/Icons/Icons";
import { Input } from "ui/Input/Input";
import { Radio } from "ui/Radio/Radio";
import { TitleM } from "ui/Typography/Typography";

type OutboundDetailsProps = {
  onBBDChange: (bbd: string) => void;
  onProductionCodeChange: (productionCode: string) => void;
  onDetailsSelect: (detail: "production_code" | "bbd_date") => void;
};

function OutboundDetails({
  onBBDChange,
  onProductionCodeChange,
  onDetailsSelect,
}: OutboundDetailsProps) {
  const intl = useIntl();
  const [selectedMetadata, setSelectedMetadata] = useState<
    "production_code" | "bbd_date" | undefined
  >(undefined);

  const handleSelectMetadata = (value: "production_code" | "bbd_date") => {
    setSelectedMetadata(value);
    onDetailsSelect(value);
  };

  return (
    <Box bg="white" borderRadius="8px" p="s200">
      <TitleM color="grey.800" mb="s200">
        {intl.formatMessage({ id: "pages.inbound.inbound-outbound.outbound-details.title" })}
      </TitleM>
      <Radio
        onChange={handleSelectMetadata}
        defaultValue={undefined}
        display="flex"
        flexDirection="column"
        mb="s200"
        gap="s200"
      >
        <Radio.Item value="bbd_date">
          <Flex align="center">
            <CalendarIcon boxSize="24px" mr="s50" />
            {intl.formatMessage({
              id: "pages.inbound.inbound-outbound.outbound-details.bbd",
            })}
          </Flex>
        </Radio.Item>
        <Radio.Item value="production_code">
          <Flex align="center">
            <InputPasswordNumbersIcon boxSize="24px" mr="s50" />
            {intl.formatMessage({
              id: "pages.inbound.inbound-outbound.outbound-details.production-code",
            })}
          </Flex>
        </Radio.Item>
      </Radio>
      {selectedMetadata === "bbd_date" && (
        <Input
          onChange={(e) => onBBDChange(e.target.value)}
          type="date"
          placeholder={intl.formatMessage({
            id: "pages.inbound.inbound-outbound.outbound-details.bbd-placeholder",
          })}
        />
      )}
      {selectedMetadata === "production_code" && (
        <Input
          onChange={(e) => onProductionCodeChange(e.target.value)}
          type="text"
          placeholder={intl.formatMessage({
            id: "pages.inbound.inbound-outbound.outbound-details.production-code-placeholder",
          })}
        />
      )}
    </Box>
  );
}

export default OutboundDetails;
